<!--Title Section-->
<app-title-jumbo title="Strategy Builder" comment="Select the best target for your portfolio and replicate it with investable products"></app-title-jumbo>

<div class="my-container">
  <!--Universe Section-->
  <section>
    <div class="container">
      <div class="offset-1 col-10">
        <mat-accordion *ngIf="currentCluster">
          <mat-expansion-panel [expanded]="false"
                               (opened)="panelOpenState = true"
                               (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ currentCluster.name }}</mat-panel-title>
              <mat-panel-description *ngIf="!panelOpenState">
                {{ currentCluster.investment_zone.name }} - {{ currentCluster.currency.name }} - {{ currentCluster.market_positions.name }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="row">
              <div class="col-6" style="line-height: 30px">
                <div class="w-100" style="border-top:1px dotted grey"></div>
                <span style="color: grey">Investment zone</span>
                <span class="float-right">{{ currentCluster.investment_zone.name }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <div class="w-100" style="border-top:1px dotted grey"></div>
                <span style="color: grey">Benchmark</span>
                <span class="float-right">{{ currentCluster.benchmark_name }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Currency</span>
                <span class="float-right">{{ currentCluster.currency.name }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Creation date</span>
                <span class="float-right">{{ currentCluster.creation_date | date:'d MMM y' }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Market positions</span>
                <span class="float-right">{{ currentCluster.market_positions.name }}</span>
                <div class="w-100" style="border-bottom:1px dotted grey"></div>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Period</span>
                <span class="float-right">
                  {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                </span>
                <div class="w-100" style="border-bottom:1px dotted grey"></div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- Card deck -->
        <div class="card-deck mt-3">

          <!-- Card Model Portfolios -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/021.png"
                   alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='universe'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-cubes fa-lg"></i>&nbsp;&nbsp;&nbsp; Target Strategies</h4>
              <!--Text-->
              <p class="card-text">A first gist with pros/cons are presented here. More information on target strategies are available in the Resources.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button (click)="onChangeBlock('universe')"><i class="fas fa-cubes mr-2"></i> Select</app-button>
            </div>

            <!--Card footer-->
            <div class="card-footer text-right">
              <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Model Portfolios -->

          <!-- Card Customize -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/022.png"
                   alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='customize'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-sliders-h fa-lg"></i>&nbsp;&nbsp;&nbsp; Improve the target</h4>
              <!--Text-->
              <p class="card-text">Depending on the target strategy selected, you may apply anticipations and see the impact on the strategy target.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button (click)="onChangeBlock('customize')"><i class="fas fa-sliders-h mr-2"></i> Customize</app-button>
            </div>

            <!--Card footer-->
            <div class="card-footer text-right">
              <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Customize -->

          <!-- Card Implement a Strategy -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/023.png"
                   alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='implement'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-arrow-alt-circle-down fa-lg"></i>&nbsp;&nbsp;&nbsp; Implement the target</h4>
              <!--Text-->
              <p class="card-text">Implement your strategy target and use it in the investment solution to complete your portfolio or to replicate it with a completeness.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button (click)="onChangeBlock('implement')"><i class="fas fa-arrow-alt-circle-down mr-2"></i> Implement</app-button>
            </div>

            <!--Card footer-->
            <div class="card-footer text-right">
              <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Implement a Strategy -->

        </div>
        <!-- Card deck -->
      </div>
    </div>

    <app-strategy-universe *ngIf="selectBlock=='universe'" (changeBlock)="onChangeBlock($event)"></app-strategy-universe>
    <app-strategy-customize *ngIf="selectBlock=='customize'" (changeBlock)="onChangeBlock($event)"></app-strategy-customize>
    <app-strategy-implement *ngIf="selectBlock=='implement'"></app-strategy-implement>

  </section>
  <!--Universe Section-->
</div>
